<template>
  <div>
    <div v-if="loading" class="loading-indicator">
      <p>Carregando...</p>
    </div>
    <div v-else>
      <form @submit.prevent="submitForm">
        <!-- Placa -->
        <b-form-group label="Placa" label-for="plate" class="mb-3">
          <multiselect
            v-if="!isEditMode"
            id="plate"
            v-model="selectedplateOption"
            :options="platesOptions"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :multiple="false"
            placeholder="Selecione a placa"
            label="text"
            track-by="value"
            class="multiselect-custom"
            required
            @input="handleplateSelect"
          />
          <b-form-input
            v-else
            disabled
            type="text"
            id="plate"
            v-model="form.plate"
            required
          ></b-form-input>
        </b-form-group>

        <!-- Data da Saída -->
        <b-form-group label="Data da Saída" label-for="exitDate" class="mb-3">
          <b-form-input
            type="date"
            id="exitDate"
            v-model="form.exitDate"
            required
          />
        </b-form-group>

        <!-- Valor -->
        <b-form-group label="Valor" label-for="value" class="mb-3">
          <b-form-input
            type="number"
            id="value"
            v-model="form.value"
            step="0.01"
            required
          />
        </b-form-group>

        <!-- Entrada de Revisão -->
        <b-form-group
          label="Entrada de Revisão"
          label-for="revisionEntry"
          class="mb-3"
        >
          <multiselect
            id="revisionEntry"
            v-model="selectedRevisionEntryOption"
            :options="revisionEntryOptions"
            :searchable="true"
            :close-on-select="true"
            :clear-on-select="false"
            :preserve-search="true"
            :multiple="false"
            placeholder="Selecione a entrada de revisão"
            label="text"
            track-by="value"
            class="multiselect-custom"
            required
            @input="handleRevisionEntrySelect"
          />
        </b-form-group>

        <!-- Botões de Ação -->
        <div class="d-flex justify-content-end mt-3">
          <b-button size="sm" type="submit" variant="green">
            {{ isEditMode ? "Atualizar" : "Registrar" }}
          </b-button>
          <b-button
            size="sm"
            variant="secondary"
            @click="$emit('close')"
            class="ml-2"
          >
            Cancelar
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        ...this.model,
        plate: this.model.plate || "",
        vehicleId: this.model.vehicleId || null,
        vehicleRevisionEntryId: this.model.vehicleRevisionEntryId || null,
        exitDate: this.model.exitDate || "",
        value: this.model.value || ""
      },
      platesOptions: [],
      selectedplateOption: null,
      revisionEntryOptions: [],
      selectedRevisionEntryOption: null,
      loading: true
    };
  },
  created: async function() {
    try {
      await this.getAllVehicleplate();
      this.initializeSelectedplate();
      this.getDropdownRevisionsEntry(this.form.vehicleId);
    } catch (error) {
      console.error("Erro ao inicializar o componente:", error);
    } finally {
      this.loading = false;
    }
  },
  watch: {
    model(newModel) {
      this.form = {
        ...newModel,
        plate: newModel.plate || "",
        vehicleId: newModel.vehicleId || null,
        vehicleRevisionEntryId: newModel.vehicleRevisionEntryId || null,
        exitDate: newModel.exitDate || "",
        value: newModel.value || ""
      };
      this.initializeSelectedplate();
      this.initializeSelectedRevisionEntry();
    }
  },
  methods: {
    async submitForm() {
      try {
        this.form.vehicleId = Number(this.form.vehicleId);
        this.form.vehicleRevisionEntryId = Number(
          this.form.vehicleRevisionEntryId
        );
        this.form.value = parseFloat(this.form.value);
        const payload = {
          ...this.form
        };
        if (this.isEditMode) {
          console.log("Atualizando saída de manutenção:", payload);
          await this.$apiVehicle.post(
            `/EditRevisionExit/${payload.id}`,
            payload
          );
        } else {
          await this.$apiVehicle.post("/CreateRevisionExit/", payload);
        }
        this.$emit("success");
      } catch (error) {
        console.error(
          this.isEditMode
            ? "Erro ao atualizar saída de manutenção:"
            : "Erro ao registrar saída de manutenção:",
          error
        );
      }
    },
    async getAllVehicleplate() {
      try {
        const response = await this.$apiVehicle.get(
          "/GetPlatesWithRevisionsEntry/"
        );
        if (Array.isArray(response.data)) {
          this.platesOptions = response.data.map(item => ({
            text: item.text,
            value: Number(item.value)
          }));
          console.log("Plates Options:", this.platesOptions);
          this.initializeSelectedplate();
        } else {
          console.error("Esperava um array, mas recebeu:", response.data);
          this.platesOptions = [];
        }
      } catch (error) {
        this.verifyExceptionType(error);
        throw error;
      }
    },
    async getDropdownRevisionsEntry(vehicleId) {
      if (!vehicleId) {
        this.revisionEntryOptions = [];
        this.selectedRevisionEntryOption = null;
        return;
      }

      try {
        const response = await this.$apiVehicle.get(
          `/GetRevisionsEntryDropdown/${vehicleId}`
        );
        if (Array.isArray(response.data)) {
          this.revisionEntryOptions = response.data.map(item => ({
            text: item.text,
            value: Number(item.value)
          }));
          console.log("Revision Entry Options:", this.revisionEntryOptions);
          this.initializeSelectedRevisionEntry();
        } else {
          console.error("Esperava um array, mas recebeu:", response.data);
          this.revisionEntryOptions = [];
        }
      } catch (error) {
        this.verifyExceptionType(error);
      }
    },
    handleplateSelect(selectedOption) {
      if (selectedOption) {
        this.form.plate = selectedOption.text;
        this.form.vehicleId = selectedOption.value;
        this.getDropdownRevisionsEntry(this.form.vehicleId);
      } else {
        this.form.plate = "";
        this.form.vehicleId = null;
        this.revisionEntryOptions = [];
        this.selectedRevisionEntryOption = null;
      }
    },
    handleRevisionEntrySelect(selectedOption) {
      if (selectedOption) {
        this.form.vehicleRevisionEntryId = selectedOption.value;
      } else {
        this.form.vehicleRevisionEntryId = null;
      }
    },
    initializeSelectedplate() {
      console.log("Inicializando placa com form:", this.form);
      console.log("Opções de placas:", this.platesOptions);
      if (this.form.plate && this.form.vehicleId !== null) {
        this.selectedplateOption = this.platesOptions.find(
          option =>
            option.text === this.form.plate &&
            option.value === this.form.vehicleId
        );
        if (!this.selectedplateOption) {
          console.warn(
            `Placa ${this.form.plate} com ID ${this.form.vehicleId} não encontrada nas opções.`
          );
        } else {
          console.log("Placa selecionada:", this.selectedplateOption);
        }
      } else {
        this.selectedplateOption = null;
      }
    },
    initializeSelectedRevisionEntry() {
      if (
        this.form.vehicleRevisionEntryId &&
        this.revisionEntryOptions.length > 0
      ) {
        this.selectedRevisionEntryOption = this.revisionEntryOptions.find(
          option => option.value === this.form.vehicleRevisionEntryId
        );
        if (!this.selectedRevisionEntryOption) {
          console.warn(
            `Entrada de Revisão com ID ${this.form.vehicleRevisionEntryId} não encontrada nas opções.`
          );
        }
      } else {
        this.selectedRevisionEntryOption = null;
      }
    },
    verifyExceptionType(error) {
      console.error("Erro na requisição:", error);
    }
  }
};
</script>

<style scoped>
.multiselect-custom {
  width: 100%;
}
.ml-2 {
  margin-left: 0.5rem;
}
.loading-indicator {
  text-align: center;
  padding: 20px;
  font-size: 1.2em;
  color: #555;
}
</style>
